<template>
  <div class="slider-item">
    <div class="title">{{title}}</div>
    <div class="interact">
      <Slider
        v-model="num"
        :startValue="startValue"
        :totalValue="totalValue"
        :unit="unit"
        :originValue="num"
        @updateValue="updateValue"
        ref="Slider"
      />
    </div>
    <input
      type="number"
      :min="startValue"
      :max="startValue + totalValue"
      :step="unit"
      class="input"
      v-model="inputValue"
      @change="onChagne($event)"
      @blur="onChagne($event)"
    />
  </div>
</template>

<script>
import Slider from './slider';
function mid (val, min, max) {
  return Math.min(Math.max(min, val), max);
}
export default {
  props: {
    name: {default: ''},
    title: {default: ''},
    startValue: { default: -100 },
    totalValue: { default: 200 },
    unit: { default: 1 },
    afterDot: { default: 0 }
  },
  components: {
    Slider
  },
  data () {
    return {
      num: 0,
      originNum: 0,
    };
  },
  computed: {
    inputValue: {
      get () {
        return this.num;
      },
      set (val) {

      }
    }
  },
  watch: {
    num (val, oldVal) {
      //   if (this.isRealNum(val)) {
      //     this.originNum = +val || 0;
      //   }
    }
  },
  methods: {
    mid (val) {
      return mid(val, this.startValue, this.startValue + this.totalValue);
    },
    fixNum (val) {
      if (!this.isRealNum(val)) {
        val = this.originNum || 0;
      }
      val = mid(val, this.startValue, this.startValue + this.totalValue);
      val = val.toFixed(this.afterDot) - 0;
      this.num = val;
      this.originNum = val;
    },
    onChagne (ev) {
      //   this.fixNum(this.num);
      let isRealNum = this.isRealNum(ev.target.value);
      if (isRealNum) {
        let val = (+ev.target.value).toFixed(this.afterDot) - 0;
        val = this.mid(val);
        if (this.num != val) {
          this.num = val;
          this.$emit('updateValueByInput', this.num, this.name);
        }
      } else {
        ev.target.value = this.num;
      }
    },
    onKeyup (ev) {
      clearTimeout(this.timer);
      let val = this.num;
      if (ev.code === 'ArrowUp') {
        val = val - 0 + 1;
      }
      if (ev.code === 'ArrowDown') {
        val = val - 0 - 1;
      }
      if (ev.code === 'ArrowUp' || ev.code === 'ArrowDown') {
        this.num = this.mid(val);
        return;
      }
      this.timer = setTimeout(() => {
        // this.fixNum(val);
        // clearTimeout(this.timer);
      }, 300);
    },
    onKeydown (ev) {
      clearTimeout(this.timer);
      let val = this.num;
      if (ev.code === 'ArrowUp') {
        val = val - 0 + 1;
      }
      if (ev.code === 'ArrowDown') {
        val = val - 0 - 1;
      }
      if (ev.code === 'ArrowUp' || ev.code === 'ArrowDown') {
        val = this.mid(val);
        this.num = val;
      }
    },
    isRealNum (n) {
      if (n === '') {
        return false;
      }
      n = +n;
      return typeof n === 'number' && !Number.isNaN(n);
    },
    updateSlider (val) {
    },
    updateValue (val, dragType) {
      this.$emit('updateValueByDrag', val, dragType, this.name);
      this.originNum = val;
    }
  }
}
</script>

<style lang="scss" scoped>
.slider-item {
  width: 226px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title {
  font-size: 12px;
  color: #737596;
}
.interact {
  flex-shrink: 0;
}
.input {
  width: 42px;
  height: 20px;
  background: #ffffff;
  border: 1px solid #d9ddea;
  border-radius: 4px;
  font-size: 12px;
  color: rgba(71, 66, 97, 1);
  text-align: center;
  outline: none;
  &:focus {
      border-color: #5778fb;
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitlePanel/sliderItem.vue